import { AlertCircle } from 'lucide-react'

/** Full-panel empty state shown when no schemas exist at all. */
export function SchemaListEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-muted-foreground">
      <AlertCircle className="h-16 w-16 mb-4 opacity-50" />
      <p className="text-lg">No schemas found</p>
      <p className="text-sm mt-2">
        Import a schema JSON from the toolbar to get started, or run the migration script.
      </p>
    </div>
  )
}
